import axios from "axios"
import { authHeader, baseUrl } from "../../utils"
import { GETTING_PAYMENTS, GET_PAYMENTS, PAYMENTS_ERROR } from "../types"

export const fetchPayments = (filterString, page, perPage) => async (dispatch) => {    
    try{
        dispatch({
            type: GET_PAYMENTS,
            payload: []
        })
        const headers = authHeader()

        let url = `${baseUrl}/payments?expand=transaction,fee,invoiceAssignment`
        if(filterString && filterString !== '') {
            url += `${url.includes('?') ? '&' : '?'}${filterString}`
        }

        if(page && page!=='') {
            url += `${url.includes('?') ? '&' : '?'}page=${page}`
        }

        if(perPage && perPage!=='') {
            url += `${url.includes('?') ? '&' : '?'}perPage=${perPage}`
        }

        dispatch( {
            type: GETTING_PAYMENTS,
            payload: true
        })

        const response = await axios.get(url, { headers })

        dispatch({
            type: GET_PAYMENTS,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch( {
            type: PAYMENTS_ERROR,
            error
        })
    }
}
